var map = {
	"./file-icons-16.svg": 258,
	"./file-icons-24.svg": 185,
	"./file-icons-40.svg": 755,
	"./icons-16.svg": 507,
	"./icons-24.svg": 440,
	"./icons-8.svg": 910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 408;